exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block; }\n\n.custom-component {\n  display: block;\n  background-color: white;\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/mobile-calendar/mobile-calendar.component.scss
// module id = ../../../../../src/app/Components/mobile-calendar/mobile-calendar.component.scss
// module chunks = 1